module.exports = __webpack_public_path__ + "static/mo37-bb42a8bd26e63f6c10295925c8e28350.png";